export default __webpack_public_path__ + "static/media/yuryu-05.0f4b9233.svg";